import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=0bbc2825&"
import script from "./CouponForm.vue?vue&type=script&lang=js&"
export * from "./CouponForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports